export const searchActionType = {
    UPDATESEARCING : "UPDATESEARCING",
    UPDATESEARCHSTRING : "UPDATESEARCHSTRING",
    UPDATESEARCHTYPE : "UPDATESEARCHTYPE",
    UPDATESEARCHRESULT : "UPDATESEARCHRESULT"
  };   